import styled, { keyframes } from 'styled-components';
import { colors } from '../../variables/colors.js';

var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var bounce = keyframes(["0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}"]);
var delay = 0.25;
var BounceLoader = styled.div.withConfig({
  displayName: "style__BounceLoader",
  componentId: "sc-1dgc39y-0"
})(["animation-duration:", "s;animation-name:", ";opacity:1;position:relative;text-align:center;width:60px;display:table;margin:0 auto;"], delay, fadeIn);
var Dot = styled.div.withConfig({
  displayName: "style__Dot",
  componentId: "sc-1dgc39y-1"
})(["animation-duration:1.4s;animation-iteration-count:infinite;animation-name:", ";background-color:", ";border-radius:100%;display:inline-block;height:14px;width:14px;:nth-child(1){animation-delay:", "s;}:nth-child(2){animation-delay:", "s;margin:auto 7px;}"], bounce, colors.darkGray, -delay, -delay / 2);

export { BounceLoader, Dot };
//# sourceMappingURL=style.js.map
